import { render } from "./ListCompanies.vue?vue&type=template&id=9c262df8"
import script from "./ListCompanies.vue?vue&type=script&lang=js"
export * from "./ListCompanies.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-reports\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__